const sign = [{
  path: 'sign/index',
  component: resolve => require(['../../../../components/pages/user/sign'], resolve)
}, {
  path: 'sign/success',
  component: resolve => require(['../../../../components/pages/user/sign/SignSuccess'], resolve)
}]

export default sign



// WEBPACK FOOTER //
// ./src/router/pages/user/sign/index.js